import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-dispatch",
  "use": "icon-dispatch-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" id=\"icon-dispatch\"><path d=\"M766.96289 895.704585v-95.854292l127.720576-95.854293H575.445886v319.493022h-63.860288v-319.493022h-127.720577v319.493022h-63.796427v-319.493022h-127.720577A191.580864 191.580864 0 0 1 0.831013 512.287415a191.580864 191.580864 0 0 1 191.517004-191.772445 191.708585 191.708585 0 0 1 191.517004 191.772445V640.071852h127.720577V128.806385l-95.790432 127.848297H320.068594L511.585598 1.021948h63.860288l191.517004 255.632734h-95.790432L575.445886 128.806385V640.071852h319.23758l-127.720576-95.854293V448.363267L1022.340182 640.071852v63.924148l-255.377292 191.708585zM320.068594 512.287415a127.784437 127.784437 0 1 0-127.720577 127.784437h127.720577V512.287415z\" p-id=\"1720\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/dispatch.svg
// module id = tVPt
// module chunks = 77